import React from "react";
import { Link } from "react-router-dom";
import avatar1png from "../../../../../assets/images/avatar-1.png";
import Shared from "../../../../../components/ReUseAbleComponents/Shared";

function SingleTopic(props) {
  return (
    <>
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-box dx-box-decorated">
                <div className="dx-blog-post">
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <h2 className="h4 mnt-5 mb-9">Having problem with Logo</h2>

                    <ul className="dx-breadcrumbs text-left dx-breadcrumbs-dark mnb-6 fs-14">
                      <li>
                        <Link to="/help-center">Support Home</Link>
                      </li>
                      <li>
                        <Link to="/forums">Forums</Link>
                      </li>
                      <li>
                        <Link to="/topics">Design with pleasure</Link>
                      </li>
                      <li>Having problem with Logo</li>
                    </ul>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-comment dx-topic-comment">
                    <div>
                      <div className="dx-comment-img">
                        <img src={avatar1png} alt="" />
                      </div>
                      <div className="dx-comment-cont">
                        <div className="dx-comment-head">
                          <Link to="/#" className="dx-comment-name">
                            John Leonard
                          </Link>
                          <span className="text-3 fs-14 mnt-5">#5630</span>
                        </div>
                        <div className="dx-comment-date">
                          12 Sep 2018 7:40 am
                        </div>
                        <div className="dx-comment-text">
                          <p className="mb-0">
                            Nullam ac dui et purus malesuada gravida id
                            fermentum orci. In eu ipsum quis urna hendrerit
                            condimentum vitae a mauris. In congue turpis purus,
                            vitae tempus ante id. Donec orci arcu, sagittis ut
                            finibus vitae.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dx-comment dx-topic-comment">
                    <div>
                      <div className="dx-comment-img">
                        <img src={avatar1png} alt="" />
                      </div>
                      <div className="dx-comment-cont">
                        <div className="dx-comment-head">
                          <Link to="/#" className="dx-comment-name">
                            Bruno Rice
                          </Link>
                          <span className="text-3 fs-14 mnt-5">#5631</span>
                        </div>
                        <div className="dx-comment-date">
                          12 Sep 2018 8:22 am
                        </div>
                        <div className="dx-comment-text">
                          <p>
                            Nullam ac dui et purus malesuada gravida id
                            fermentum orci. In eu ipsum quis urna hendrerit
                            condimentum vitae a mauris. In congue turpis purus,
                            vitae tempus ante id. Donec orci arcu, sagittis ut
                            finibus vitae.
                          </p>
                          <blockquote className="dx-blockquote dx-blockquote-style-2">
                            <span className="dx-blockquote-title mnt-6">
                              Quote by John Leonard:
                            </span>
                            <p className="mnb-6">
                              Suspendisse, litora pellentesque habitasse nisi,
                              maecenas conubia mauris lectus nec purus gravida
                              integer netus cras viverra eleifend, diam aenean.
                              Rutrum Mauris nisi scelerisque adipiscing facilisi
                              mi metus.
                            </p>
                          </blockquote>
                          <p className="mb-0">
                            Consectetuer facilisi dictumst ad scelerisque.
                            Ultrices dignissim bibendum turpis pulvinar.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <ul className="dx-pagination">
                      <li className="dx-pagination-icon">
                        <Link to="/#">
                          <span className="icon pe-7s-angle-left"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/#">1</Link>
                      </li>
                      <li className="dx-pagination-space">...</li>
                      <li>
                        <Link to="/#">8</Link>
                      </li>
                      <li className="active">
                        <Link to="/#">9</Link>
                      </li>
                      <li>
                        <Link to="/#">10</Link>
                      </li>
                      <li className="dx-pagination-space">...</li>
                      <li>
                        <Link to="/#">18</Link>
                      </li>
                      <li className="dx-pagination-icon">
                        <Link to="/#">
                          <span className="icon pe-7s-angle-right"></span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-blog-post-box">
                    <h3 className="h6 mb-25">Write a Reply</h3>
                    <form className="dx-form" action="#">
                      <div className="dx-form-group">
                        <div className="dx-editor-quill">
                          <div
                            className="dx-editor"
                            data-editor-height="150"
                            data-editor-maxHeight="250"
                          ></div>
                        </div>
                      </div>
                      <div className="dx-form-group">
                        <div
                          className="dx-dropzone"
                          data-dropzone-action="#"
                          data-dropzone-maxMB="5"
                          data-dropzone-maxFiles="5"
                        >
                          <div className="dz-message">
                            <div className="dx-dropzone-icon">
                              <span className="icon pe-7s-cloud-upload"></span>
                            </div>
                            <div className="h6 dx-dropzone-title">
                              Drop files here or click to upload
                            </div>
                            <div className="dx-dropzone-text">
                              <p className="mnb-5 mnt-1">
                                You can upload up to 5 files (maximum 5 MB each)
                                of the following types: .jpg, .jpeg, .png, .zip.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row justify-content-between vertical-gap dx-dropzone-attachment">
                          <div className="col-auto dx-dropzone-attachment-add">
                            <label className="mb-0 mnt-7">
                              <span className="icon fas fa-paperclip mr-10"></span>
                              <span>Add Attachment</span>
                            </label>
                          </div>
                          <div className="col-auto dx-dropzone-attachment-btn">
                            <button
                              className="dx-btn dx-btn-lg"
                              type="button"
                              name="button"
                            >
                              Submit a ticket
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className="dx-sticky dx-sidebar"
                data-sticky-offsetTop="120"
                data-sticky-offsetBot="40"
              >
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">
                    {" "}
                    Subscribe to Newsletter{" "}
                  </div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Articles </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      How to manually import Demo data (if you faced with
                      problems in one-click demo import)
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Make menu dropdown working without JavaScript
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Add top menu link inside dropdown on mobile devices
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Forum Topics </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Need help with customization. Some options are not
                      appearing...
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      My images on profile and item pages doesnt show up?! Whats
                      the matter?
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Theme not updating in downloads
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleTopic;
